'use client';

import { useEffect } from 'react';

import { useTranslations } from '@/i18n/useTranslations';
import { useNoSubscriptionPopup } from '@/lib/ui/useNoSubscriptionPopup';

import PopupShell from './PopupShell';
import Spinner from '@/ui/components/Spinner';

import button from '@/styles/button.module.sass';
import divs from '@/styles/divs.module.sass';
import text from '@/styles/text.module.sass';
import styles from './index.module.sass';

const MANAGE_SUBSCRIPTION_URL = 'https://t.me/neovpn?start';

export default function NoSubscriptionPopup() {
  const { t } = useTranslations('Popup');
  const open = useNoSubscriptionPopup((s) => s.open);
  const hide = useNoSubscriptionPopup((s) => s.hide);
  const retry = useNoSubscriptionPopup((s) => s.payload?.retry);

  useEffect(() => {
    if (!open || !retry) return;
    const interval = window.setInterval(retry, 3000);
    return () => window.clearInterval(interval);
  }, [open, retry]);

  return (
    <PopupShell open={open} onClose={hide}>
      <div className={divs.flexCl8}>
        <h2 className={text.h2}>{t('header')}</h2>
        <div className={divs.flex8}>
          <p className={text.p}>{t('subheader')}</p>
          <Spinner />
        </div>
      </div>
      <hr className={styles.divider} />
      <p className={text.p}>Либо оформите подписку в боте @neovpn с планом Trinity или Morpheus</p>
      <div className={`${button.hWrapper} ${styles.actions}`}>
        <button className={button.secondary} onClick={hide}>
          {t('close')}
        </button>
        <a
          className={button.accent}
          href={MANAGE_SUBSCRIPTION_URL}
          target="_blank"
          rel="noreferrer"
        >
          Открыть @neovpn
        </a>
      </div>
    </PopupShell>
  );
}
